export default __webpack_public_path__ + "static/media/g2019-4.2461f71c.jpeg";